// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  GOOGLE_MAPS_API_KEY: "AIzaSyDA5dZ4Dbclsm4RMmYGt1_vvRyEzF0SA9k",
  "PreUAT": {
    "CONTEXT_PATH": "iLoungeServices",
    "VCONNECT_CONTEXT_PATH": "iConnectUATServices",
    "D2C_CONTEXT_PATH": "masterservice",
    "EAPPS_CONTEXT_PATH": "eappspolicyservices",
    "EKYC_CONTEXT_PATH": "eKycServices",
    "REDIRECTION_URL_PREFIX": "https://api.royalsundaram.net/PGHandlerTest/",
    "MSG_REDIRECTION_URL_PREFIX": "http://api.royalsundaram.net/MOPISWEB/",
    "EAPPS_URL_PREFIX": "http://mopiswebtst.ind.rsa-ins.com/",
    "EAPPS_RENEWAL_BULK_DOWNLOAD": "https://mopis.royalsundaram.net/MOPISTEST/",
    "MEDICARE_TPA_URL": "https://www.medibuddy.in/networkHospitals",
    "PARAMOUNT_TPA_URL": "https://www.paramounttpa.com/PolicyClaim/PolyClaimStatus.aspx",
    "VCONNECT_BACKEND_URL_PREFIX": "http://rsgitstm70:9010/",
    "IPOLICY_BACKEND_URL_PREFIX": "http://rsgitstm96:19090/iPolicy/",
    "D2C_BACKEND_URL_PREFIX": "https://mstest.royalsundaram.in/",
    "CHAT_BOT_URL":"https://runtime.dhee.ai/web-widget/dhee-launcher.js?instanceId=rs-ilounge-uat",
    "COMMERCIAL_URL" : "https://commercial.royalsundaram.net/fire/#/login?ctoken=",
    "EKYC_URL_PREFIX": "https://ekyc.royalsundaram.net/",
    "D2C_ONPREMISE_BACKEND_URL_PREFIX": "https://dtcsit.royalsundaram.net/",
    "D2C_ONPREMISE_CONTEXT_PATH": "Services",
    "PAYMENTGW":"https://api.royalsundaram.net/web/test/paymentgateway",
    "NEXUS_PORTAL_URL":"https://testclubroyal.rewardsnloyalty.in/",
    "IPOLICYV2_URL_PREFIX":"http://rsgitstm96:19090/iPolicyV2/",
    "CPM_URL":"https://commercial.royalsundaram.net/bb1/home?ctoken=",
    "UDAYAN_URL_PREFIX":"http://10.46.28.214/",
    "EPICX_AI_URL" : "https://rsepicx.royalsundaram.net",
    "BACKEND_URL_PREFIX" : "https://routetwo.royalsundaram.net/"
  },
  "UAT": {
    "CONTEXT_PATH": "iLoungeServices",
    "VCONNECT_CONTEXT_PATH": "iConnectUATServices",
    "D2C_CONTEXT_PATH": "masterservice",
    "EAPPS_CONTEXT_PATH": "eappspolicyservices",
    "EKYC_CONTEXT_PATH": "eKycServices",
    "REDIRECTION_URL_PREFIX": "https://api.royalsundaram.net/PGHandlerTest/",
    "MSG_REDIRECTION_URL_PREFIX": "http://api.royalsundaram.net/MOPISWEB/",
    "EAPPS_URL_PREFIX": "http://rsgitstm260:8090/",
    "EAPPS_RENEWAL_BULK_DOWNLOAD": "http://inmmdutst01:8010/MOPISTEST/",
    "MEDICARE_TPA_URL": "https://www.medibuddy.in/networkHospitals",
    "PARAMOUNT_TPA_URL": "https://www.paramounttpa.com/PolicyClaim/PolyClaimStatus.aspx",
    "VCONNECT_BACKEND_URL_PREFIX": "http://rsgitstm70:9010/",
    "IPOLICY_BACKEND_URL_PREFIX": "http://rsgitstm116:9001/iPolicy/",
    "D2C_BACKEND_URL_PREFIX": "https://mstest.royalsundaram.in/",
    "CHAT_BOT_URL":"https://runtime.dhee.ai/web-widget/dhee-launcher.js?instanceId=rs-ilounge-uat",
    "COMMERCIAL_URL" : "https://commercial.royalsundaram.net/fire/#/login?ctoken=",
    "EKYC_URL_PREFIX": "https://ekyc.royalsundaram.net/",
    "D2C_ONPREMISE_BACKEND_URL_PREFIX": "https://dtcsit.royalsundaram.net/",
    "D2C_ONPREMISE_CONTEXT_PATH": "Services",
    "PAYMENTGW":"https://api.royalsundaram.net/web/test/paymentgateway",
    "NEXUS_PORTAL_URL":"https://testclubroyal.rewardsnloyalty.in/",
    "IPOLICYV2_URL_PREFIX":"https://dtcapptest.royalsundaram.in/iPolicyV2/",
    "CPM_URL":"https://commercial.royalsundaram.net/bb1/home?ctoken=",
    "UDAYAN_URL_PREFIX":"https://api.royalsundaram.net/",
    "EPICX_AI_URL" : "https://rsepicx.royalsundaram.net",
    "BACKEND_URL_PREFIX" : "https://routetwo.royalsundaram.net/"
  },
  "UAT_Ext": {
    "CONTEXT_PATH": "iLoungeServices",
    "VCONNECT_CONTEXT_PATH": "iConnectUATServices",
    "D2C_CONTEXT_PATH": "masterservice",
    "EAPPS_CONTEXT_PATH": "eappspolicyservices",
    "EKYC_CONTEXT_PATH": "eKycServices",
    "REDIRECTION_URL_PREFIX": "https://api.royalsundaram.net/PGHandlerTest/",
    "MSG_REDIRECTION_URL_PREFIX": "http://api.royalsundaram.net/MOPISWEB/",
    "EAPPS_URL_PREFIX": "https://api.royalsundaram.net/",
    "EAPPS_RENEWAL_BULK_DOWNLOAD": "https://mopis.royalsundaram.net/MOPISTEST/",
    "MEDICARE_TPA_URL": "https://www.medibuddy.in/networkHospitals",
    "PARAMOUNT_TPA_URL": "https://www.paramounttpa.com/PolicyClaim/PolyClaimStatus.aspx",
    "VCONNECT_BACKEND_URL_PREFIX": "https://api.royalsundaram.net/",
    "IPOLICY_BACKEND_URL_PREFIX": "https://ilounge.royalsundaram.net/iPolicy/",
    "D2C_BACKEND_URL_PREFIX": "https://mstest.royalsundaram.in/",
    "CHAT_BOT_URL":"https://runtime.dhee.ai/web-widget/dhee-launcher.js?instanceId=rs-ilounge-uat",
    "COMMERCIAL_URL" : "https://commercial.royalsundaram.net/fire/#/login?ctoken=",
    "EKYC_URL_PREFIX": "https://ekyc.royalsundaram.net/",
    "D2C_ONPREMISE_BACKEND_URL_PREFIX": "https://dtcsit.royalsundaram.net/",
    "D2C_ONPREMISE_CONTEXT_PATH": "Services",
    "PAYMENTGW":"http://rsgitstm116:8180/web/dtctest/paymentgateway",
    "NEXUS_PORTAL_URL":"https://testclubroyal.rewardsnloyalty.in/",
    "IPOLICYV2_URL_PREFIX":"https://dtcapptest.royalsundaram.in/iPolicyV2/",
    "CPM_URL":"https://commercial.royalsundaram.net/bb1/home?ctoken=",
    "UDAYAN_URL_PREFIX":"https://api.royalsundaram.net/",
    "EPICX_AI_URL" : "https://rsepicx.royalsundaram.net",
    "BACKEND_URL_PREFIX" : "https://routetwo.royalsundaram.net/"
  },
  "PreLive": {
    "CONTEXT_PATH": "iLoungeServices",
    "EAPPS_CONTEXT_PATH": "eappspolicyservices",
    "EKYC_CONTEXT_PATH": "eKycServices",
    "REDIRECTION_URL_PREFIX": "https://www.royalsundaram.in/PGHandler/",
    "MSG_REDIRECTION_URL_PREFIX": "http://rsgitstm05:9090/iLoungePolicy/",
    "EAPPS_URL_PREFIX": "http://preui/",
    "EAPPS_RENEWAL_BULK_DOWNLOAD": "http://inmchn367:17020/MOPIS/",
    "MEDICARE_TPA_URL": "https://www.medibuddy.in/networkHospitals",
    "PARAMOUNT_TPA_URL": "https://www.paramounttpa.com/PolicyClaim/PolyClaimStatus.aspx",
    "VCONNECT_CONTEXT_PATH": "iConnectServices",
    "VCONNECT_BACKEND_URL_PREFIX": "http://10.46.195.241/",
    "IPOLICY_BACKEND_URL_PREFIX": "http://rsgitstm05:9090/iPolicy/",
    "D2C_CONTEXT_PATH": "masterservice",
    "D2C_BACKEND_URL_PREFIX": "https://msstage.royalsundaram.in/",
    "COMMERCIAL_URL":"https://commercial.royalsundaram.in/fire/#/FireInsurance/login?ctoken=",
    "CHAT_BOT_URL":"https://runtime.dhee.ai/web-widget/dhee-launcher.js?instanceId=i-lounge",
    "EKYC_URL_PREFIX": "https://ekyc.royalsundaram.net/",
    "D2C_ONPREMISE_BACKEND_URL_PREFIX": "https://www.royalsundaram.in/",
    "D2C_ONPREMISE_CONTEXT_PATH": "Services",
    "PAYMENTGW":"https://api.royalsundaram.net/web/test/paymentgateway",
    "NEXUS_PORTAL_URL":"https://testclubroyal.rewardsnloyalty.in/",
    "IPOLICYV2_URL_PREFIX":"https://dtcapptest.royalsundaram.in/iPolicyV2/",
    "CPM_URL":"https://commercial.royalsundaram.net/bb1/home?ctoken=",
    "EPICX_AI_URL" : "https://rsepicx.royalsundaram.net",
    "BACKEND_URL_PREFIX" : "https://routetwo.royalsundaram.net/",
  },
  "LIVE": {
    "CONTEXT_PATH": "iLoungeServices",
    "EAPPS_CONTEXT_PATH": "eappspolicyservices",
    "D2C_CONTEXT_PATH": "masterservice",
    "EKYC_CONTEXT_PATH": "eKycServices",
    "REDIRECTION_URL_PREFIX": "https://www.royalsundaram.in/PGHandler/",
    "MSG_REDIRECTION_URL_PREFIX": "http://einsure/iLoungePolicy/",
    "EAPPS_URL_PREFIX": "http://einsure/",
    "EAPPS_RENEWAL_BULK_DOWNLOAD": "http://eappslb/MOPIS/",
    "MEDICARE_TPA_URL": "https://www.medibuddy.in/networkHospitals",
    "PARAMOUNT_TPA_URL": "https://www.paramounttpa.com/PolicyClaim/PolyClaimStatus.aspx",
    "VCONNECT_CONTEXT_PATH": "iConnectServices",
    "VCONNECT_BACKEND_URL_PREFIX": "http://10.46.195.241/",
    "IPOLICY_BACKEND_URL_PREFIX": "http://inmchn302:8080/iPolicy/",
    "D2C_BACKEND_URL_PREFIX": "https://mslive.royalsundaram.in/",
    "COMMERCIAL_URL":"https://commercial.royalsundaram.in/fire/#/FireInsurance/Home",
    "CHAT_BOT_URL":"https://runtime.dhee.ai/web-widget/dhee-launcher.js?instanceId=i-lounge",
    "EKYC_URL_PREFIX": "https://ekyc.royalsundaram.net/",
    "D2C_ONPREMISE_BACKEND_URL_PREFIX": "https://www.royalsundaram.in/",
    "D2C_ONPREMISE_CONTEXT_PATH": "Services",
    "PAYMENTGW":"https://api.royalsundaram.net/web/test/paymentgateway",
    "NEXUS_PORTAL_URL":"https://testclubroyal.rewardsnloyalty.in/",
    "IPOLICYV2_URL_PREFIX":"https://dtcapptest.royalsundaram.in/iPolicyV2/",
    "CPM_URL":"https://commercial.royalsundaram.net/bb1/home?ctoken=",
    "EPICX_AI_URL" : "https://rsepicx.royalsundaram.net",
    "BACKEND_URL_PREFIX" : "https://routetwo.royalsundaram.net/"
  },
  "LIVE_Ext": {
    "CONTEXT_PATH": "iLoungeServices",
    "EAPPS_CONTEXT_PATH": "eappspolicyservices",
    "D2C_CONTEXT_PATH": "masterservice",
    "EKYC_CONTEXT_PATH": "eKycServices",
    "REDIRECTION_URL_PREFIX": "https://www.royalsundaram.in/PGHandler/",
    "MSG_REDIRECTION_URL_PREFIX": "https://www.royalsundaram.in/iLoungePolicy/",
    "EAPPS_URL_PREFIX": "https://cover.royalsundaram.in/",
    "EAPPS_RENEWAL_BULK_DOWNLOAD": "https://www.royalsundaram.in/MOPIS/",
    "MEDICARE_TPA_URL": "https://www.medibuddy.in/networkHospitals",
    "PARAMOUNT_TPA_URL": "https://www.paramounttpa.com/PolicyClaim/PolyClaimStatus.aspx",
    "VCONNECT_CONTEXT_PATH": "iConnectServices",
    "VCONNECT_BACKEND_URL_PREFIX": "https://www.royalsundaram.in/",
    "D2C_BACKEND_URL_PREFIX": "https://mslive.royalsundaram.in/",
    "IPOLICY_BACKEND_URL_PREFIX": "https://www.royalsundaram.in/iPolicy/",
    "COMMERCIAL_URL":"https://commercial.royalsundaram.in/fire/#/FireInsurance/Home",
    "CHAT_BOT_URL":"https://runtime.dhee.ai/web-widget/dhee-launcher.js?instanceId=i-lounge",
    "EKYC_URL_PREFIX": "https://ekyc.royalsundaram.net/",
    "D2C_ONPREMISE_BACKEND_URL_PREFIX": "https://www.royalsundaram.in/",
    "D2C_ONPREMISE_CONTEXT_PATH": "Services",
    "PAYMENTGW":"https://api.royalsundaram.net/web/test/paymentgateway",
    "NEXUS_PORTAL_URL":"https://testclubroyal.rewardsnloyalty.in/",
    "IPOLICYV2_URL_PREFIX":"https://dtcapptest.royalsundaram.in/iPolicyV2/",
    "CPM_URL":"https://commercial.royalsundaram.net/bb1/home?ctoken=",
    "EPICX_AI_URL" : "https://rsepicx.royalsundaram.net",
    "BACKEND_URL_PREFIX" : "https://routetwo.royalsundaram.net/"
  },
  "apk_UAT": {
    "TOKENPOINT": "http://10.46.221.10/",
    "CONTEXT_PATH": "iLoungeServices",
    "EAPPS_CONTEXT_PATH": "eappspolicyservices",
    "BACKEND_URL_PREFIX" : "https://routetwo.royalsundaram.net/",
    "REDIRECTION_URL_PREFIX": "https://api.royalsundaram.net/PGHandlerTest/",
    "MSG_REDIRECTION_URL_PREFIX": "https://ilounge.royalsundaram.net/iLoungeAppPolicy/",
    "EAPPS_URL_PREFIX": "https://api.royalsundaram.net/",
    "EAPPS_RENEWAL_BULK_DOWNLOAD": "https://mopis.royalsundaram.net/MOPISTEST/",
    "MEDICARE_TPA_URL": "https://www.medibuddy.in/networkHospitals",
    "PARAMOUNT_TPA_URL": "https://www.paramounttpa.com/PolicyClaim/PolyClaimStatus.aspx",
    "PAYMENTGW":"https://api.royalsundaram.net/web/test/paymentgateway",
    "VCONNECT_CONTEXT_PATH": "iConnectUATServices",
    "VCONNECT_BACKEND_URL_PREFIX": "https://api.royalsundaram.net/",
    "IPOLICY_BACKEND_URL_PREFIX": "https://ilounge.royalsundaram.nety/iPolicy/",
    "D2C_CONTEXT_PATH": "masterservice",
    "D2C_BACKEND_URL_PREFIX": "https://mstest.royalsundaram.in/",
    "D2C_ONPREMISE_CONTEXT_PATH": "Services",
    "D2C_ONPREMISE_BACKEND_URL_PREFIX": "https://dtcsit.royalsundaram.net/",
    "EKYC_CONTEXT_PATH": "eKycServices",
    "CHAT_BOT_URL":"https://runtime.dhee.ai/web-widget/dhee-launcher.js?instanceId=rs-ilounge-uat",
    "COMMERCIAL_URL" : "https://commercial.royalsundaram.net/fire/#/login?ctoken=",
    "EKYC_URL_PREFIX": "https://ekyc.royalsundaram.net/",
    "NEXUS_PORTAL_URL":"https://testclubroyal.rewardsnloyalty.in/",
    "IPOLICYV2_URL_PREFIX":"https://dtcapptest.royalsundaram.in/iPolicyV2/",
    "CPM_URL":"https://commercial.royalsundaram.net/bb1/home?ctoken=",
    "EPICX_AI_URL" : "https://rsepicx.royalsundaram.net"
  },
  "apk_LIVE": {
    "CONTEXT_PATH": "iLoungeServices",
    "EAPPS_CONTEXT_PATH": "eappspolicyservices",
    "D2C_CONTEXT_PATH": "masterservice",
    "EKYC_CONTEXT_PATH": "eKycServices",
    "REDIRECTION_URL_PREFIX": "https://www.royalsundaram.in/PGHandler/",
    "MSG_REDIRECTION_URL_PREFIX": "https://ilounge.royalsundaram.in/iLoungeAppPolicy/",
    "EAPPS_URL_PREFIX": "https://www.royalsundaram.in/",
    "EAPPS_RENEWAL_BULK_DOWNLOAD": "https://www.royalsundaram.in/MOPIS/",
    "MEDICARE_TPA_URL": "https://www.medibuddy.in/networkHospitals",
    "PARAMOUNT_TPA_URL": "https://www.paramounttpa.com/PolicyClaim/PolyClaimStatus.aspx",
    "VCONNECT_CONTEXT_PATH": "iConnectServices",
    "VCONNECT_BACKEND_URL_PREFIX": "https://www.royalsundaram.in/",
    "IPOLICY_BACKEND_URL_PREFIX": "https://ilounge.royalsundaram.in/iPolicy/",
    "D2C_BACKEND_URL_PREFIX": "https://mslive.royalsundaram.in/",
    "COMMERCIAL_URL":"https://commercial.royalsundaram.in/fire/#/FireInsurance/Home",
    "CHAT_BOT_URL":"https://runtime.dhee.ai/web-widget/dhee-launcher.js?instanceId=i-lounge",
    "EKYC_URL_PREFIX": "https://kyc.royalsundaram.in/",
    "D2C_ONPREMISE_BACKEND_URL_PREFIX": "https://www.royalsundaram.in/",
    "D2C_ONPREMISE_CONTEXT_PATH": "Services",
    "PAYMENTGW":"https://www.royalsundaram.in/web/dtc/paymentgateway",
    "BACKEND_URL_PREFIX" : "https://routetwo.royalsundaram.net/",
    "NEXUS_PORTAL_URL":"https://testclubroyal.rewardsnloyalty.in/",
    "IPOLICYV2_URL_PREFIX":"https://dtcapptest.royalsundaram.in/iPolicyV2/",
    "CPM_URL":"https://commercial.royalsundaram.net/bb1/home?ctoken=",
    "EPICX_AI_URL" : "https://rsepicx.royalsundaram.net"
  },
  "selectedEnv": "UAT",
  "context": "iLoungeApp",
  "enableMotor": true,
  "enableCPA": true,
  "enableManufacturerModule": true,
  "enableIPolicyMenu": false,
  "DD_RUM_CLIENT_TOKEN":"pub77f63a70a4591a8a34bcebbcae1d5ae2",
	"DD_RUM_APPLICATION_ID":"826b160a-781f-4e28-a2a9-2e93912c3924",
	"DD_RUM_SITE":"datadoghq.com",
	"DD_RUM_SERVICE":"i-lounge",
	"DD_RUM_ENV":"UAT",
	"DD_RUM_PRIVACY_LEVEL":"mask-user-input",
  "ANDROID_URL":"https://play.google.com/store/apps/details?id=com.rs.ilounge",
  "IOS_URL":"https://apps.apple.com/in/app/ilounge-app/id6449897436",
	"DD_RUM_ALLOWED_URLS":[ "https://api.royalsundaram.net/", "https://ilounge.royalsundaram.net/", "https://mopis.royalsundaram.net/", "https://www.medibuddy.in/","https://www.paramounttpa.com/",
  "https://ilounge.royalsundaram.net/", "https://mstest.royalsundaram.in/", "http://RSGITSTM96:8090/", "https://runtime.dhee.ai/", "https://commercial.royalsundaram.net/", "https://ekyc.royalsundaram.net/",
  "https://dtcsit.royalsundaram.net/", "http://rsgitstm116:8180/", "https://testclubroyal.rewardsnloyalty.in/", "https://ilounge.royalsundaram.in/"],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
